import appCity from "../../views/appSettings/city.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("city", {
    url: "city/:id",
    parent: "app",
    views: {
      view: {
        template: appCity,
      },
    },
    reloadOnSearch: false,
    data: { title: "City" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/city/city.urls.js